export const EndPoints = {
    Account: {
        SignIn: "/hotel-inn/auth/login",
        SignUp: "/hotel-inn/auth/register"
    },
    BaseURL: 'http://localhost:9000/'
}